import { IThoiKhoaBieuDeleteMultipleRequest } from "../models/request/thoi-khoa-bieu/IThoiKhoaBieuDeleteMultipleRequest";
import { IThoiKhoaBieuDuplicateRequest } from "../models/request/thoi-khoa-bieu/IThoiKhoaBieuDuplicateRequest";
import { IThoiKhoaBieuItemSelectRequest } from "../models/request/thoi-khoa-bieu/IThoiKhoaBieuItemSelectRequest";
import { ITKBChiTietSaveExcelRequest } from "../models/request/thoi-khoa-bieu/ITKBChiTietSaveExcelRequest";
import { ITKBChiTietSelectByDateRequest } from "../models/request/thoi-khoa-bieu/ITKBChiTietSelectByDateRequest";
import { ITKBChiTietSelectRequest } from "../models/request/thoi-khoa-bieu/ITKBChiTietSelectRequest";
import { pl_tkb_chitiet } from "../models/response/thoi-khoa-bieu/pl_tkb_chitiet";
import { apiClient } from "./apiClient";
import { BaseCRUDApi } from "./baseCRUDApi";

export const API_TKB_CHITIET_PATH = "thoi-khoa-bieu-chi-tiet"

class TKBChiTietApi extends BaseCRUDApi<pl_tkb_chitiet> {
    constructor({ path }: { path: string; }) {
        super(path);
    }
    Select(rq: IThoiKhoaBieuItemSelectRequest) {
        return apiClient.post(`thoi-khoa-bieu/select`, rq)
    }
    SelectByTkb(request: ITKBChiTietSelectRequest) {
        return apiClient.post(`${this._path}/select-by-tkb`, request)
    }
    SelectByGiaoVien(request: ITKBChiTietSelectByDateRequest) {
        return apiClient.post(`${this._path}/select-by-giaovien`, request)
    }
    LoadFromExcel(request: FormData) {
        return apiClient.upload(`${this._path}/load-from-excel`, request)
    }
    SaveDataExcel(request: ITKBChiTietSaveExcelRequest) {
        return apiClient.post(`${this._path}/save-data-excel`, request)
    }
    Duplicate(request: IThoiKhoaBieuDuplicateRequest) {
        return apiClient.post(`${this._path}/duplicate`, request)
    }
    DeleteMultipleAsync(request: IThoiKhoaBieuDeleteMultipleRequest) {
        return apiClient.post(`${this._path}/deletes-multiple`, request)
    }
}
export const thoiKhoaBieuChiTietApi = new TKBChiTietApi({ path: API_TKB_CHITIET_PATH });

